import type {ContentRelationshipField, FilledContentRelationshipField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import type {
  GlossaryPageDocumentData,
  PageDocumentData,
  PickContentRelationshipFieldData,
  Simplify,
} from 'prismicio-types'
import type {FC} from 'react'
import {Icon} from 'src/common/Icon'

type BreadcrumbsProps = {
  parentPage?:
    | ContentRelationshipField<'page', string, PageDocumentData>
    | FilledContentRelationshipField<
        'glossary_page',
        string,
        PickContentRelationshipFieldData<
          {
            id: 'glossary_page'
            fields: [
              {
                id: 'breadcrumbs'
                fields: ['label', 'link']
              },
              'title',
            ]
          },
          Simplify<GlossaryPageDocumentData>,
          string
        >
      >
  title: string
}

const toSentenceCase = (uid: string): string => {
  const words = uid.replace(/-/g, ' ')

  return words.charAt(0).toUpperCase() + words.slice(1)
}

export const Breadcrumbs: FC<BreadcrumbsProps> = ({parentPage, title}) => {
  if (!isFilled.contentRelationship(parentPage) || !parentPage.data?.breadcrumbs) {
    return null
  }

  return (
    <div className="flex items-center gap-1">
      <a
        href={parentPage.url}
        className="text-13 font-medium leading-normal tracking-[.13px] text-moss-grey-400 hover:text-moss-grey-300"
      >
        {parentPage.data?.breadcrumbs[0]?.label}
      </a>
      {title && (
        <>
          <Icon name="chevron-v2" className="size-2 rotate-90 text-moss-black" />
          <span className="text-13 font-medium leading-normal tracking-[.13px] text-moss-black">
            {toSentenceCase(title)}
          </span>
        </>
      )}
    </div>
  )
}
